import { InputText } from 'components/atoms'
import { Form } from 'components/molecules'
import * as React from 'react'
import 'react-dates/initialize'
import styled, { AnyStyledComponent } from 'styled-components'
import I18n from '../../../../core/i18n'
import { reservationService } from '../../../../core/services'
import * as constants from '../../../../static/constants'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

interface IReceiptModalProps {
  reservationId: number
  createReceiptFormRef: any
  setReceiptId(id: number): void
  handleUpdated(id: number): void
}

const ReceiptModalBody: React.FC<IReceiptModalProps> = props => {
  const [errors, setErrors] = React.useState<{ receipt_address: null | string }>({
    receipt_address: null,
  })
  const handleSubmit = async (initialValues, values) => {
    const { receipt } = await reservationService.createReceipt({
      name: values.receipt_address,
      reservation_id: props.reservationId,
    })
    props.setReceiptId(receipt.id)
    props.handleUpdated(receipt.id)
  }

  return (
    <div>
      <Form
        ref={props.createReceiptFormRef}
        fields={{ receipt_address: 'receipt_address' }}
        handleUpdateForm={(updatedErrors, isSubmitEnabled) => setErrors(updatedErrors)}
        handleSubmit={handleSubmit}
      >
        <InputText
          required={true}
          name="receipt_address"
          label={I18n.t('receipt.receipt_address')}
          error={errors.receipt_address}
          defaultValue=""
        />
        <S.Note>{I18n.t('receipt.note')}</S.Note>
      </Form>
    </div>
  )
}

const S: { [key: string]: AnyStyledComponent } = {}

S.Note = styled.div`
  font-size: 14px;
  color: ${constants.COLORS.cautionText};
  margin-left: 240px;
  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    margin-left: 0;
  }
`
export default ReceiptModalBody
